import cx from 'classnames';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, IconName} from 'components';
import {SessionGoal, SessionGoalType} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';
import {buildTranslationKey} from 'utils/transform';

const SESSION_T_KEYS = TRANSLATION_KEYS.COMMON.SESSION;

type Props = {
    goal: SessionGoal;
    className?: string;
}

export const GoalName: React.FC<Props> = ({goal, className}: Props) => {
    const {t} = useTranslation();

    const renderGoal = useCallback((icon: IconName, label: string) => (
        <div className={cx('tw-flex tw-items-center', className)}>
            <Icon name={icon} className='tw-mr-2' />
            {label}
        </div>
    ), [className]);

    if (goal.type === SessionGoalType.Screenshot) {
        return renderGoal('screenshots', goal.data?.screenshotName);
    }
    if (goal.type === SessionGoalType.AsyncRequest) {
        return renderGoal('play', t(SESSION_T_KEYS.ASYNC_REQUEST.TYPE[buildTranslationKey(goal.data?.asyncRequestType)]));
    }
    return null;
};
